import { ConditionType, HeaderElement } from '@ridango/core';

export const defaultHeaderMenuItems = [
    {
        path: '/purchase/ticket',
        label: 'HEADER_PERIOD_TICKETS'
    },
    {
        path: '/purchase/wallet',
        label: 'HEADER_ADD_MONEY'
    },
    {
        path: '/purchase/garage',
        label: 'HEADER_BIKE_GARAGE'
    },
    {
        path: '/map',
        label: 'HEADER_MAP'
    },
    {
        path: '/personalize',
        label: 'HEADER_PERSONALIZE',
        subPaths: [
            {
                path: '/personalize/travelcard',
                label: 'SUB_HEADER_PERSONALIZE'
            },
            {
                path: '/personalize/isic-card',
                label: 'HEADER_ISIC_CARD_ACTIVATION'
            }
        ]
    },
    {
        path: '/explore',
        label: 'HEADER_EXPLORE'
    },
    {
        path: '/journey-planner',
        label: 'HEADER_JOURNEY_PLANNER'
    },
    {
        path: '/disruption-messages',
        label: 'HEADER_DISRUPTION_MESSAGES'
    },
    {
        path: '/book-a-ride',
        label: 'HEADER_BOOK_RIDE',
        condition: [ConditionType.SHOW_BOOK_ARIDE]
    },
    {
        path: '/bankcard-tickets',
        label: 'HEADER_BANKCARD_TICKETS'
    },
    {
        path: '/account',
        label: 'HEADER_MY_ACCOUNT',
        condition: [ConditionType.AUTH_REQUIRED],
        subPaths: [
            {
                path: '/account/related-cards',
                label: 'MY_ACCOUNT_CARDS_ACTIVE_TICKETS',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/tickets',
                label: 'HEADER_TICKETS',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/cards',
                label: 'APP_MENU_CARD',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/purchase-history',
                label: 'MY_ACCOUNT_PURCHASE_HISTORY',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/validation-history',
                label: 'MY_ACCOUNT_VALIDATION_HISTORY',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/notification-settings',
                label: 'MY_ACCOUNT_NOTIFICATION_SETTINGS',
                condition: [ConditionType.AUTH_REQUIRED]
            },
            {
                path: '/account/profile',
                label: 'MY_ACCOUNT_PROFILE',
                condition: [ConditionType.AUTH_REQUIRED]
            }
        ]
    }
];

export const mobileHeaderMenuItems: HeaderElement[] = [
    {
        path: '/feedback',
        label: 'FEEDBACK_MOBILE_MENU_TITLE'
    },
    {
        path: '/terms-and-conditions',
        label: 'MOBILE_MENU_TERSM_AND_CONDITIONS'
    },
    {
        path: '/privacy-policy',
        label: 'MOBILE_MENU_PRIVACY_POLICY'
    }
];
